var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { isPromiseLike } from './utilityTypes';
/**
 * 等待一段时间
 * @param time 等待的毫秒数
 */
export function wait(time) {
    return new Promise(function (resolve) { return setTimeout(resolve, time); });
}
// 用来标识终端超时的 error
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(message) {
        if (message === void 0) { message = 'timeout'; }
        return _super.call(this, message) || this;
    }
    return TimeoutError;
}(Error));
export { TimeoutError };
/**
 * 为函数设置超时
 * @param func 待设置超时的函数
 * @param time 以毫秒为单位的超时时间
 * @param onTimeout 超时时的处理逻辑
 * @returns 带超时的函数
 */
export function timeout(func, time, onTimeout) {
    if (time === void 0) { time = 0; }
    if (onTimeout === void 0) { onTimeout = function () { return Promise.reject(new TimeoutError()); }; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var tasks = [func.call.apply(func, __spreadArray([this], args))];
        if (time > 0) {
            tasks.push(wait(time).then(onTimeout));
        }
        return Promise.race(tasks);
    };
}
/**
 * 为函数添加重试逻辑
 * @param func 待重试的函数
 * @param times 重试的次数
 * @param time 重试的间隔毫秒数
 * @return 带重试的函数
 */
export function retry(func, times, time) {
    if (times === void 0) { times = 1; }
    if (time === void 0) { time = 0; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var syncResult, e_1, e_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 1, , 4]);
                        syncResult = func.call.apply(func, __spreadArray([this], args));
                        return [3 /*break*/, 4];
                    case 1:
                        e_1 = _c.sent();
                        if (!(times > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, wait(time)];
                    case 2:
                        _c.sent();
                        return [2 /*return*/, (_a = retry(func, times - 1, time)).call.apply(_a, __spreadArray([this], args))];
                    case 3: 
                    // 重试次数用尽
                    throw e_1;
                    case 4:
                        if (!(isPromiseLike(syncResult) && times > 0)) return [3 /*break*/, 9];
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 9]);
                        return [4 /*yield*/, syncResult];
                    case 6: return [2 /*return*/, _c.sent()];
                    case 7:
                        e_2 = _c.sent();
                        return [4 /*yield*/, wait(time)];
                    case 8:
                        _c.sent();
                        return [2 /*return*/, (_b = retry(func, times - 1, time)).call.apply(_b, __spreadArray([this], args))];
                    case 9: return [2 /*return*/, syncResult];
                }
            });
        });
    };
}
